module.exports = __webpack_public_path__ + "img/antes_despues_201.bcecc34c.png";